(function(window, undefined) {
	"use strict";
	var BrioSrvc = function(ssocoreServices, userSrvc) {
		this.userSrvc = userSrvc;
		this.ssocoreServices = ssocoreServices;
		this.brioVersion = 'brio2';
		
		var self = this;

		this.goTo = function(app, stato, parametri) {
			ssocoreServices.accediDaEntryPoint({
				app: app,
				nome: stato,
				parametri: parametri
			});
		};
	};

	BrioSrvc.$inject = [ 'ssocoreServices', 'FinUserSrvc'];

	angular.module("cbl.finanza.mf").service("FinBrioSrvc", BrioSrvc);
}(window));


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finBrioSrvc.js
 ** module id = 29
 ** module chunks = 0 1 2
 **/